<div
  class="textarea"
  [class.textarea--error]="this.hasError"
  [class.textarea--disabled]="this.isDisabled"
>
  <qr-icon
    *ngIf="config && config.icon"
    class="textarea__icon"
    [name]="config.icon"
    [color]="iconColor"
  ></qr-icon>
  <textarea
    class="textarea__input"
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit($event)"
    [placeholder]="config?.placeholder ? config?.placeholder : ''"
    [disabled]="isDisabled ? true : false"
    (focus)="focusIn.emit(true)"
  ></textarea>
</div>
<p
  class="hint"
  *ngIf="config?.hint"
  [class.hint--error]="hasError"
  [class.hint--disabled]="isDisabled"
>
  {{ config?.hint }}
</p>
